import { useMemo } from 'react';
import { observer } from 'mobx-react';
import { useDependencies } from '@servicetitan/react-ioc';
import { IPartnerOverview } from '@servicetitan/marketing-tenant-management-api';
import { TenantsStore } from '../../stores/tenants.store';
import { LoadStatus } from '../../../common/enums/load-status';
import { MultiValueFilter } from './multi-value-filter/multi-value-filter';

export const PartnerFilter = observer(() => {
    const [{ partnersFilter, partners, partnersLoadStatus, filterByPartner }] =
        useDependencies(TenantsStore);

    const options = useMemo(
        () =>
            partners.map(({ id, name }) => ({
                key: id,
                value: id,
                text: name,
            })),
        [partners],
    );

    const handleApply = (selectedValues: IPartnerOverview['id'][]) => {
        filterByPartner(selectedValues);
    };

    return (
        <MultiValueFilter
            label="Partner"
            options={options}
            onApply={handleApply}
            appliedValues={partnersFilter}
            loading={partnersLoadStatus === LoadStatus.Loading}
        />
    );
});
